// Constants for different requests for current reducer
export default {
  tourLog: 'TOUR_LOG',
  tourLogReport: 'TOUR_LOG_REPORT',
};
